import { createContext, useContext, useState, ReactNode } from 'react';

export type DeviceContextType = {
    cartesianPatterns: boolean,
    setCartesianPatterns: Function,
    patterns: any[],
    setPatterns: Function,
};

// Create the context
const DeviceContext = createContext<DeviceContextType | undefined>(undefined);

// Define the provider props
interface ThemeContextProviderProps {
    children: ReactNode;
}

// Create the provider component
export default function DeviceContextProvider({ children }: ThemeContextProviderProps) {
    const [cartesianPatterns, setCartesianPatterns] = useState(false);
    const [patterns, setPatterns] = useState<any[]>([]);

    return (
        <DeviceContext.Provider 
            value={{ 
                cartesianPatterns,
                setCartesianPatterns,
                patterns,
                setPatterns
            }}
        >
            {children}
        </DeviceContext.Provider>
    );
}

// Create the hook
export function useDeviceContext() {
    const context = useContext(DeviceContext);
    if (context === undefined) {
        throw new Error('useDeviceContext must be used within a DeviceContextProvider');
    }
    return context;
}
